/* eslint-disable no-param-reassign */
/* eslint-disable import/no-mutable-exports */
import { createApi } from '@meitu/catalyze';
import type { AxiosRequestConfig } from 'axios';
import useVipModalStore, { loggleVipModal } from '$/store/useVipModalStore';
import { addCommonParams, addCommonHeaders } from './helpers';
import { createRequestErrorMiddleware } from './middlewares/createRequestErrorMiddleware';
import APP from './api';

let agentTeamRequestApi: ReturnType<typeof createApi> | undefined;

interface AgentTeamRequestConfig extends AxiosRequestConfig {
  skipClientOId?: boolean;
}

export interface AgentTeamApiConfig {
  baseUrl?: string;
  extraParams?: Record<string, any>;
  extraHeaders?: Record<string, any>;
}

/**
 * 创建 Agent Team 请求实例，并统一注入公共参数、鉴权及当前团队请求头。
 */
const agentTeamCreateApi = (apiConfig?: AgentTeamApiConfig) => {
  const extraParams = apiConfig?.extraParams;
  const extraHeaders = apiConfig?.extraHeaders;

  agentTeamRequestApi = createApi({
    baseURL: apiConfig?.baseUrl || APP.roboneo.baseAgentTeamURL(),
    withCredentials: true,
    timeout: 30000,
    transformResponse: [
      // 转换data字符串
      function transform(data: any) {
        if (data && data instanceof ArrayBuffer) {
          return data;
        }

        return data;
      },
    ],
  });
  agentTeamRequestApi.modifyApiInstance((api) => {
    // 构建中间件数组
    const middlewares: any[] = [createRequestErrorMiddleware()];

    api.interceptors.request.use(
      async (config) => {
        const commonParams = addCommonParams();
        const mergedParams = { ...commonParams, ...extraParams };
        if (config.data && typeof config.data === 'object') {
          config.data = { ...mergedParams, ...config.data };
        } else {
          config.data = { ...mergedParams };
        }
        if (config.method?.toLowerCase() === 'get' && config.params) {
          config.params = { ...mergedParams, ...config.params };
        }
        const requestConfig = config as AgentTeamRequestConfig;
        await addCommonHeaders(requestConfig);
        if (extraHeaders) {
          config.headers = { ...config.headers, ...extraHeaders };
        }
        return config;
      },
      (error) => {
      // eslint-disable-next-line no-console
        console.log(error, '请求失败');
        return error;
      },
    );

    api.interceptors.response.use(
      (response) => {
        // 在成功响应后自动查询剩余额度
        if (response.config?.url && response.config.url.includes(APP.roboneo.api.taskSubmit)) {
          const { updateAmountCb } = useVipModalStore.getState();
          // 重置订阅的状态
          loggleVipModal(false);
          // 异步调用额度查询，不阻塞当前请求
          setTimeout(() => {
            updateAmountCb?.();
          }, 3000);
        }
        return middlewares.reduce((resp, middleware) => {
          return middleware.onResponse ? middleware.onResponse(resp) || resp : resp;
        }, response);
      },
      (error) => {
        middlewares.forEach((mw) => mw.onError && mw.onError(error));
        return Promise.reject(error);
      },
    );
  });
};

export { agentTeamCreateApi, agentTeamRequestApi };
